/* eslint-disable */
/// This file is auto generated - do not edit manually
export const Heading = 'Website.Basket.Wrapping.DeleteOrEditConfirmation.Heading';
export const Message = 'Website.Basket.Wrapping.DeleteOrEditConfirmation.Message';
export const ConfirmButton = 'Website.Basket.Wrapping.DeleteOrEditConfirmation.ConfirmButton';
